import * as yup from "yup";
import { Max, Min, Validation } from "../../utils/Validation.utils";
export const ConditionInitialValues = {
    name: ""
};
export const ConditionSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.Name, Validation.Max)
        .required(Validation.Required)
});
